import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../../api/db';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiTrendingUp, FiClock } = FiIcons;

const Sidebar = () => {
  const [recentArticles, setRecentArticles] = useState([]);

  useEffect(() => {
    const load = async () => {
      const articles = await db.getArticles(true);
      setRecentArticles(articles.slice(0, 5));
    };
    load();
  }, []);

  return (
    <aside className="space-y-8">
      {/* Popular Section (Mocked logic using recent for now) */}
      <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
        <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
          <SafeIcon icon={FiTrendingUp} style={{ color: 'var(--brand-primary)' }} />
          Popular Articles
        </h3>
        <ul className="space-y-4">
          {recentArticles.slice(0, 3).map((article, idx) => (
            <li key={article.id} className="group">
              <Link to={`/blog/${article.slug}`} className="flex gap-4 items-start">
                <span className="text-2xl font-bold text-gray-200 transition-colors">
                  0{idx + 1}
                </span>
                <div>
                  <h4 className="text-sm font-semibold text-gray-800 transition-colors line-clamp-2 leading-tight" style={{ '--hover-color': 'var(--brand-primary)' }}>
                    {article.title}
                  </h4>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>

      {/* Recent Section */}
      <div className="bg-gray-50 rounded-2xl p-6 border border-gray-100">
        <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
          <SafeIcon icon={FiClock} style={{ color: 'var(--brand-primary)' }} />
          Recent Posts
        </h3>
        <div className="space-y-4">
          {recentArticles.map(article => (
            <Link key={article.id} to={`/blog/${article.slug}`} className="block group">
              <h4 className="text-sm font-medium text-gray-700 transition-colors line-clamp-2 mb-1">
                {article.title}
              </h4>
              <p className="text-xs text-gray-500">
                {new Date(article.created_at).toLocaleDateString('en-GB', { month: 'short', day: 'numeric', year: 'numeric' })}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;